import React from "react";
import styled from "styled-components"

const Styled={
    MenuRecommendBox:styled.div`
        width:59px;
        height:20px;
        margin-right:5px;
        border-radius:5px;
        background-color:#FFECCF;
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:column;
    `,
        MenuRecommendText:styled.p`
            font-size:10px;
            font-weight:400;
            color:#FFA621;
            font-family:'PreFont';
        `,
}

const BossRecomend=()=>{
    return(
        <Styled.MenuRecommendBox>
            <Styled.MenuRecommendText>사장님 추천</Styled.MenuRecommendText>
        </Styled.MenuRecommendBox>
    )
}
export default BossRecomend
